/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Failed_InjuriesInputs */

const en_us2_onboarding_failed_injuries = /** @type {(inputs: Onboarding_Failed_InjuriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stopped while saving where it hurts.`)
};

const pt_br2_onboarding_failed_injuries = /** @type {(inputs: Onboarding_Failed_InjuriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao salvar onde dói.`)
};

const es_419_onboarding_failed_injuries = /** @type {(inputs: Onboarding_Failed_InjuriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se detuvo al guardar dónde te duele.`)
};

const pt_pt2_onboarding_failed_injuries = /** @type {(inputs: Onboarding_Failed_InjuriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao guardar onde dói.`)
};

const fr_fr2_onboarding_failed_injuries = /** @type {(inputs: Onboarding_Failed_InjuriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrompu pendant l'enregistrement de tes douleurs.`)
};

const de_de2_onboarding_failed_injuries = /** @type {(inputs: Onboarding_Failed_InjuriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Speichern deiner Schmerzstellen ist es hängen geblieben.`)
};

const it_it2_onboarding_failed_injuries = /** @type {(inputs: Onboarding_Failed_InjuriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è interrotto mentre salvava dove ti fa male.`)
};

/**
* | output |
* | --- |
* | "It stopped while saving where it hurts." |
*
* @param {Onboarding_Failed_InjuriesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_failed_injuries = /** @type {((inputs?: Onboarding_Failed_InjuriesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Failed_InjuriesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_failed_injuries(inputs)
	if (locale === "es-419") return es_419_onboarding_failed_injuries(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_failed_injuries(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_failed_injuries(inputs)
	if (locale === "de-DE") return de_de2_onboarding_failed_injuries(inputs)
	if (locale === "it-IT") return it_it2_onboarding_failed_injuries(inputs)
	return en_us2_onboarding_failed_injuries(inputs)
});
export { onboarding_failed_injuries as "onboarding.failed_injuries" }